import LeftMenu from "@/components/frame/leftMenu.vue"

const en ={
    message:{
      "title": "IoT Cloud Monitoring Platform", // 物联网监控云平台
      "upload": "Upload", // 上传
      "returnList": "Return", // 返回列表
      "return": "Return", // 返回列表
      "placeholderTips": "please Enter", // 请输入
      "home": "Home", // 首页
      "more": "more", // 更多
      "loading": "loading...", // 加载中...
      "loadingCureve": "loading curve....", // 正在加载数据中...
      "noCureveData": "no curve data", // 无曲线数据
      "realTabName1": "Real monitoring", // 实时监控
      "realTabName2": "Basic information", // 基本信息
      "realTabName3": "Using or adding", // 入料用料
      "realTabName4": "Parameter settings", // 参数设置
      "realTabName5": "Feeding record", // 喂料记录
      'language':'中文切换',
      common:{
        "all":"All",//全部
        "online": "Online", // 在线
        "outline": "Offline", // 离线
        "maintain": "Waiting", // 待接入
        "open": "On", // 开机
        "stop": "Off", // 停机
        "put": "Filling", // 入料
        "out": "Withdrawal", // 出料
        "days": "days", // 天
        "notConnected":"not connected"//未接入
      },
      topMenu:{
        "index": "Home", // 主页
        "devices": "Devices", // 设备管理
        "statistics": "Statistics", // 统计查询
        "enterprise": "Enterprise Mgmt", // 企业管理
        "afterSale": "Support", // 产品售后
        "system": "System", // 系统管理
        "message": "Message", // 消息管理
        "setting": "Setting", // 设置
        "logout": "Logout", // 退出
        "hello": "Hello", // 您好
        "cockpit": "Cockpit", // 进入驾驶舱
        "profile": "Profile", // 个人信息
        "profileTitle": "Profile", // 个人信息
        "userName": "Name", // 用户姓名
        "loginAccount": "Account", // 登录账号
        "lastLoginDate": "Last Login" // 上次登录日期
      },
      leftMenu:{
        "title": "Menu", // 菜单栏
        "lm0": "IoT Monitoring Cloud Platform", // 物联网管理平台
        "lm1": "Device Monitoring Dashboard", // 设备可视化
        "lm2": "Feeding Management Dashboard", // 养殖可视化
        "lm3": "Device Management", // 设备管理
        "lm4": "Device Transfer Records", // 迁移记录
        "lm5": "Fill Records", // 入料统计
        "lm6": "Withdrawal Records", // 用料统计
        "lm7": "Activity Logs", // 操作记录
        "lm8": "Warning Records", // 报警记录
        "lm9": "Conection Records", // 连接记录
        "lm10": "Alarm Settings", // 预警设置
        "lm11": "Feeding Settings", // 养殖管理
        "lm12": "Feeding Records", // 喂养记录
        "lm13": "Feeding Standards", // 喂料标准
        "lm14": "Device Distribution", // 设备分布
        "lm15": "Use Report", // 使用报表
        "lm16": "Reserve Statistics", // 储量统计图
        "lm17": "Feeding Report", // 充料报表
        "lm18": "Enterprise User", // 企业用户
        "lm19": "Enterprise Management", // 企业管理
        "lm20": "Enterprise Upgrade Package", // 企业升级包
        "lm21": "Feedback", // 意见反馈
        "lm22": "Fault Management", // 故障管理
        "system": "System Management", // 系统管理
        "lm23": "User Management", // 用户管理
        "lm24": "Department Management", // 部门管理
        "lm25": "Role Management", // 角色管理
        "lm26": "Data Dictionary", // 数据字典
        "lm27": "System Log", // 系统日志
        "lm28": "Product Management", // 产品管理
        "lm29": "Dead Record", // 死亡记录
        "lm30": "Product Advertising", // 产品宣传
        "lm31": "Data Update", // 数据更新
        "lm32": "Device Monitor", // 设备监控
        "lm33": "Connection Record", // 连接记录
        "lm34": "Statistics Query", // 统计查询
        "lm35": "System Configuration", // 系统配置
        "lm36": "Offline Statistics", // 离线统计
        "lm37": "Device Payment Reminder", // 设备缴费提醒
        "lm38": "Logo Setting", // logo设置
        "lm39": "Device Location", // 设备定位
        "lm40": "Interfaces", // 设备定位
        "lm41":"Records appeal",
        "lm42":"System Message", // 系统消息
        "lm50":"help center", // 帮助中心
        "lm51":"Comprehensive Report", // 综合报表
        "lm52":"Finance Center", // 财务中心
        "lm53":"Balance Account Management", // 余额账户管理
        

        
      },
      btn:{
        "group1": "Control Settings", // 控制设置
        "group2": "Weighing Settings", // 称重设置
        "group3": "Parameter Settings", // 参数设置
        "refresh": "Refresh", // 刷新
        "search": "Search", // 搜索
        "reset": "Reset", // 重置
        "add": "Add", // 添加
        "edit": "Edit", // 编辑
        "delete": "Delete", // 删除
       "confirm": "Confirm", // 确认
        "save": "Save", // 保存
        "cancel": "Cancel", // 取消
        "close": "Close", // 关闭
        "submit": "Submit", // 提交
        "resetPwd": "Reset Password", // 重置密码
        "addBatch": "Bulk Add", // 批量添加
        "batchMigration": "Bulk Transfer", // 批量迁移
        "batchModify": "Bulk Edit", // 批量修改
        "batchRestart": "Bulk Restart", // 批量重启
        "batchHeart":"Bulk setHeart", //批量设置心跳
        "batchAllow":"Bulk allow", //批量允许工作
        "batchStop":"Bulk stop",//批量停止工作
        "updateIot": "Update IoT", // 更新三元组
        "batchImport": "Import", // 导入
        "batchExport": "Export", // 导出
        "allow_work": "Start", // 允许工作
        "stop_work": "Stop", // 停止工作
        "restart_controller": "Restart", // 重启控制器
        "clear_zero": "Clear Zero", // 清零
        "full_scale": "Full Scale", // 满量程
        "division_value_calibration": "Div Value Calib", // 分度值标定
        "weight_calibration": "Weight Calib", // 砝码标定
        "remote_address": "Remote Addr", // 远程地址
        "filter_coefficient": "Filter Coeff", // 滤波系数
        "sensor_type_setting": "Sensor Type Set", // 传感器类型设置
        "status_threshold": "Status Thresh", // 状态阈值
        "zero_setting_1": "Zero Set 1", // 归零设置1
        "zero_setting_2": "Zero Set 2", // 归零设置2
        "sensitivity_and_decimal_setting": "Sens & Dec Set", // 感量和小数点设置
        "creep_tracking_setting": "Creep Track Set", // 蠕变追踪设置
        "weighing_speed_filter_mode": "Weigh Speed/Filter", // 称重速度/数字滤波方式
        "filter_value_1": "Filter Val 1", // 滤波值1
        "filter_value_2": "Filter Val 2", // 滤波值2
        "heartbeat_interval": "Heartbeat Int", // 心跳间隔
        "local_calibration_password": "Local Calib Pass", // 本地标定密码
        "server_ip": "Server IP", // 服务器IP
        "server_ip_2": "Server IP 2", // 服务器IP2
        "stockAlertThreshold": "Stock Alert Threshold" // 存量报警阈值
      },
      "index": {
        "title": "Home", // 首页
        "protocolStatistics": "Protocol Statistics", // 协议统计
        "productStatistics": "Product Statistics", // 产品统计
        "pendingAfterSale": "Pending After-sales", // 待处理售后
        "faultStatistics": "Fault Statistics", // 故障统计
        "faultStatisticsTitle": "Fault Statistics (Total: {total} times)", // 故障统计 (总计: {total}次)
        "faultCount": "Fault Count", // 故障数量
        "noFaultData": "No Fault Data", // 暂无故障数据
        "noData": "No Data", // 暂无数据
        "times": " times", // 次
        "percentage": "Percentage", // 占比
        "pendingFaults": "{count} faults pending", // 待{count}条故障处理
        "pending": "Pending", // 待处理
        "processing": "In Progress", // 处理中
        "completed": "Completed", // 已完成
        "dataSummary": "Data Summary", // 数据汇总
        "allDevice": "All Monitoring", // 总监控
        "onlineDevice": "Online Devices", // 在线设备
        "enterprise": "Enterprises", // 企业
        "OnlineTrend": "Online Trend (Last Year)", // 近一年在线趋势
        "yearGrowthTrend": "Year Growth Trend", // 年增长趋势
        "yearNewDevice": "Annual Devices", // 年新增设备
        "yearNewEnterprise": "Annual Enterprises", // 年新增企业
        "monthNewDevice": "Monthly Devices", // 月新增设备
        "userFeedback": "User Feedback", // 用户反馈
        "noPendingTasks": "No Pending Tasks" // 暂无待处理任务
      },
      "index1": {
          "zjkssb": "Total Monitored Devices", // 总监控设备(台)
          "zxsb": "Online Devices", // 在线设备(台)
          "lxsb": "Offline Devices", // 离线设备(条)
          "jryj": "Today's Alerts", // 今日预警
          "jrsl": "Daily Fill (Tons)", // 今日上料(t)
          "jryl": "Daily Withdrawal", // 今日用料
          "cltj": "Stock Level Chart", // 储量统计图
          "gzdt": "Work Dynamics", // 工作动态
          "prompt": "Due to the large number of items, friendly display is not possible. Please select a company to view!" // 由于数量过大无法友好显示，请您选择企业进行查看！
      },
      "units": {
          "kg": "kg", // 千克
          "sets": "sets", // 台
          "Enterprises": "", // 家
          "ton": "t" // 吨
      },
     "real": {
        "title": "Real monitoring", // 实时监控
        "dataCurve": "trend (more)", // 数据曲线（更多）
        "weightTitle": "Instrument weight", // 仪表重量
        "todayFeed": "Daily Fill", // 今日上料
        "todayUse": "Daily Withdrawal", // 今日用料
        "stateMonitor": "State monitoring", // 状态监控
        "dataMonitor": "Data monitoring", // 数据监控
        "basicInfo": "Basic Info", // 基本信息
        "sensorMonitor": "Sensor monitoring", // 传感器监控
        "title1": "Last time", // 通讯时间
        "title2": "Valve power", // 阀门电源
        "title3": "Valve", // 阀门
        "title4": "Shake motor", // 震动电机
        "title5": "Pump", // 水泵
        "title6": "Mixer motor", // 搅拌电机
        "title7": "Number", // 编号
        "title8": "Internal Number", // 内部编号
        "title9": "Attribute", // 设备属性
        "title10": "Capacity", // 容量
        "nmdjk": "NMD Mon", // 内码数据监控
        "xmtd": "Proj/Chan", // 项目/通道
        "jnmd": "Net NMD", // 净内码
        "nmdpc": "NMD Dev", // 净码偏差
        "zjzt": "Leg Stat", // 支脚状态
        "jnmdh": "Net NMD Sum", // 净内码和
        "jnmdjz": "Net NMD Avg", // 净内码均值
        "ztsl": "Leg Count", // 支腿数量
        "pcbj": "Dev Alarm", // 偏差报警
        "domode": "DO Mode", // DO模式
        "cgqzt": "Sensor Stat", // 传感器状态
        "zxqc": "Online", // 在线且正常
        "lx": "Offline", // 离线
        "zx": "Online", // 在线
        "wjr": "Not Conn", // 未接入
        "mfzt": "Valve Stat", // 阀门状态
        "xlz": "Feeding", // 下料中
        "slz": "Loading", // 上料中
        "jp": "Idle", // 静置
        "high": "High", // 偏高
        "low": "Low", // 偏低
        "normal": "Normal", // 正常
        "weight": "Weight", // 重量
        "adValue": "AD Value" // AD值
    },
    "tooltip": {
        "hideQuery": "Hide query" // 隐藏查询条件
    },
    "deviceAlarm": {
        "ytjTitle": "Add all-in-one alarm",
        "ruleName": "Rule name",
        "ruleNamePlaceholder": "Please input rule name",
        "alarmInterval": "Alarm mute interval",
        "intervalUnit": "Unit: 1 minute",
        "tel": "Receiver mobile",
        "telPlaceholder": "11-digit mobile number",
        "protocolType": "Protocol type",
        "protocolPlaceholder": "Please select protocol type",
        "company": "Company",
        "companyPlaceholder": "Please select company",
        "isSend": "Send SMS",
        "isVoice": "Voice notify",
        "isEnable": "Alarm switch",
        "astTitle": "Complex condition (AST tree editor)",
        "astTips": "Select protocol type first to load fields, then edit AND/OR and leaf conditions.",
        "tipRuleName": "Please input rule name",
        "tipSelectProtocol": "Please select protocol type",
        "tipSelectCompany": "Please select company",
        "tipTel": "Please input receiver mobile",
        "saveFail": "Save failed",
        "noConfigId": "No config ID returned",
        "saveTreeFail": "Condition tree save failed",
        "saveSuccess": "Saved successfully"
    },
    "deviceList": {
        "title": "Device list", // 设备列表
        "title1": "Device ID", // 序号
        "title2": "Number", // 编号
        "title3": "Internal Code", // 企业编号
        "title4": "Device attribute", // 设备属性
        "title5": "Attribute", // 属性
        "title6": "Capacity (t)", // 容量(t)
        "title7": "Current Weight", // 余量
        "title8": "Silo Fill Rate", // 仓满率
        "title9": "SIM card", // SIM卡
        "title10": "Calibration Status", // 标定状态
        "title11": "Status", // 状态
        "title12": "Product", // 产品
        "title13": "Model", // 型号
        "title14": "Version", // 版本
        "title15": "Operation", // 操作
        "cond1": "Enterprise", // 企业
        "cond2": "Product", // 产品
        "cond3": "Keywords", // 关键字
        "cond4": "Weight", // 重量
        "cond5": "Version", // 版本
        "cond6": "Status", // 状态
        "cond7": "Protocol", // 协议
        "cond8":"order",//排序,
        "view": "view", // 监控
        // 提示框
        "pl1": "Please select enterprise", // 请选择企业
        "pl2": "Please select product", // 请选择产品
        "pl3": "Device ID, Attribute", // 编号、设备属性、SIM
        "pl4": "Weight1", // 重量1
        "pl5": "Weight2", // 重量2
        "pl6": "Version", // 版本
        "pl7": "All", // 全部
        "pl8": "Please select status", // 请选择状态
        "online": "Online", // 在线
        "outline": "Offline", // 离线
        "all": "All", // 全部
        "unit1": "", // 台,
        "hideSearchConditions": "Hide Search Bar",
        "refresh": "Refresh",
        "cardMode": "Switch to Card View",
        "listMode": "Switch to List View", 
        "temperature": "Target Temperature", // 温度
        "avgTemperature": "Avg Temperature", 
        "humidity": "Humidity", // 湿度
        "stock": "Stock", // 存栏
        "age": "Age", // 日龄
        "flowAccumulated": "Flow Accumulated", // 流量累计
        "topSpray": "Top Spray", // 顶部喷淋
        "sideSpray": "Side Spray", // 侧面喷淋
        "wastewaterPumpSpray": "Wastewater Pump Spray", // 排污泵喷淋
        "walkCount": "Walk Count", // 行走次数
        "leftCarPosition": "Left Car Position", // 左车位置
        "rightCarPosition": "Right Car Position", // 右车位置
        //刮粪机
        "position1": "1# Position", // 1#当前位置
        "speed1": "1# Speed", // 1#行走速度
        "operations1": "1# Operations", // 1#运行次数
        "position2": "2# Position", // 2#当前位置
        "speed2": "2# Speed", // 2#行走速度
        "operations2": "2# Operations" // 2#运行次数
    },
    "deviceCard": {
        "product": "Product", // 产品
        "attr": "Attribute", // 属性
        "target": "Target", // 目标
        "dStatus": "D-Status", // 标定状态
        "capacity": "Capacity", // 容量
        "states": "States", // 状态
        "still": "Idle", // 静置
        "adding": "Adding", // 上料中
        "using": "Using" // 用料中
      },
      "breedRecord": {
        "breedState": "Breed State",
        "networkState": "Network State",
        "zrls": "Total Entry", // 总入栏数
        "dqls": "Current Num", // 当前数量
        "jcsl": "Avg Intake", // 均采食量
        "jrrl": "Today In", // 今日入料
        "ljrl": "Total In", // 累计入料
        "jzgz": "Avg Weight", // 均重估值
        "jryl": "Daily Withdrawal", // 今日用料
        "ljyl": "Total Use", // 累计用料
        "lrb": "Ratio", // 料肉比
        "zl": "Weight", // 重量
        "cml": "Full Rate", // 仓满率
        "ydy": "Days Fed", // 已饲养天数
        "ywc": "Completed", // 已完成
        "byz":"Preparation Status"
    },
      deviceInfor:{
        "jbxx": "Basic Info", // 基本信息
        "sbcs": "Dev Params", // 设备参数
        "bdxx": "Calib Info", // 标定信息
        "qtxx": "Other Info", // 其他信息
        "qy": "Enterprise", // 企业
        "bh": "Device ID", // 编号
        "qynbbh": "Internal Code", // 企业内部编号
        "sbzs": "Dev Attr", // 设备属性
        "sx": "Attr", // 属性
        "fzr": "Resp Pers", // 负责人
        "sim": "SIM", // SIM
        "sbscqy": "Device MFR", // 设备生产企业
        "kzqscqy": "Controller MFR", // 控制器生成企业
        "ybmx": "Indicator Model", // 仪表型号
        "cpfl": "Prod Cat", // 产品分类
        "xy": "Proto", // 协议
        "xtlb": "Sys Type", // 系统类别
        "rl": "Cap", // 容量
        "cg": "Bin Height(m)" ,//仓高
        "kwrl": "Emp Cap", // 空仓容量
        "nbfdz": "Int Div", // 内部分度值
        "kgadz": "Emp AD", // 空罐AD值
        "eddl": "Rated Cur", // 额度电流
        "djgl": "Motor Pow", // 电机功率
        "sbxh": "Dev Model", // 设备型号
        "bjsx": "Alarm Lim", // 报警限制
        "cgxlx": "Sensor Type", // 传感器类型
        "dw": "Unit", // 单位
        "scbs": "Upload Mult", // 上传倍数
        "xsd": "Dec Point", // 小数点
        "ybbb": "Instr Ver", // 仪表版本
        "mzbb": "Mod Ver", // 模组版本
        "plcbb": "PLC Ver", // PLC版本
        "bdzt": "Calib Stat", // 标定状态
        "cjsh": "Create Time", // 创建时间
        "cjr": "Creator", // 创建人
        "bz": "Notes", // 备注
        "bz2": "MgmtNote", // 备注
        "ly": "Source", // 来源
        "sensorCount": "Sensor Count", // 传感器显示数量
        "statInfeed": "Statistics Infeed", // 统计入料
        "connectAddr": "Connect Addr", // 连接地址
        "enable": "Enable",                // 开启
        "disable": "Disable"               // 关闭
      },
      settingPage:{
        "xh": "Seq No", // 序号
        "czr": "Operator", // 操作人
        "cznr": "Operation", // 操作内容
        "czsj": "Timestamp" // 操作时间
      },
      realRlyl:{
        "j2yslfx": "Recent Material Analysis Chart", // 近期用料上料分析图
        "ylkg": "Withdrawal (kg)", // 用料(kg)
        "rlkg": "Fill (kg)", // 入料(kg)
        "rlxx": "Fill Records", // 入料信息
        "ylxx": "Withdrawal Records", // 用料信息
        "xh": "Seq No", // 序号
        "sj": "Time", // 时间
        "zl": "Weight", // 重量
        "sfqr": "Confirmation Status?", // 是否确认
        "ck": "View", // 查看
        "jrr": "Today", // 今日
        "wqr": "Unconfirmed", // 未确认
        "yqr": "Confirmed" // 已确认
    }, 
    loginPage:{
      "title": "Smart Livestock IoT Platform",   
      "subtitle": "Intelligent · Automated · Digital Livestock Management",
      "welcome": "Welcome",
      "loginSubtitle": "Enter Smart Livestock Management Platform",
      "username": "Account",  
      "password": "Password",
      "oldSystem": "Old System Login",
      "login": "Login",
      "enterUsername": "Please enter account", 
      "enterPassword": "Please enter password",
      "feature1": "Smart Automation",
      "feature2": "AI Data Analytics",
      "feature3": "Real-time Monitoring",
      "feature4": "Precision Management",
      "mobileAccess": "Mobile Access",
      "scanToLogin": "Scan to Login",
      "wechatQr": "WeChat QR Code",
      "miniprogramQr": "Mini Program QR Code",
      "copyright": "All Rights Reserved",
      "icp": "豫ICP备12002457号-9"
     },
    "setting": {
          "systemSettings": "System Settings", // 系统设置
          "settings": "Settings", // 设置
          "defaultProduct": "Default Product", // 默认产品
          "securitySettings": "Security Settings", // 安全设置
          "oldPassword": "Old Password", // 旧密码
          "newPassword": "New Password", // 新密码
          "confirmNewPassword": "Confirm New Password", // 确认新密码
          "enterNewPassword": "Please enter new password", // 请输入新密码
          "reEnterNewPassword": "Please enter the new password again", // 请再次输入新密码
          "passwordsDoNotMatch": "Two passwords do not match", // 两次密码不匹配
          "enterOldPassword": "Please enter old password", // 请输入旧密码
          "paramsOutError": "Output Error Threshold", // 出料误差阈值
          "paramsInError": "Input Error Threshold", // 进料误差阈值
          "paramsCalcError": "Calculation Tolerance Range", // 计算容差范围
          "paramsSetting": "Input/Output Parameter Settings", // 出入料参数设置
          "paramsSaveSuccess": "Parameters saved successfully", // 参数保存成功
          "errorMessage": "Error Message", // 错误信息
          "companyInfo": "Company Information", // 企业信息
          "companyName": "Company Name", // 企业名称
          "companyAddress": "Company Address", // 企业地址
          "companyPhoto": "Company Photo", // 企业照片
          "selectFile": "Select File", // 选取附件
          "enterParamsOutError": "Please enter output error threshold", // 请输入出料误差阈值
          "enterParamsInError": "Please enter input error threshold", // 请输入进料误差阈值
          "enterParamsCalcError": "Please enter calculation tolerance range", // 请输入计算容差范围
          "unit": "Unit", // 单位
          "unitKg": "kg", // 单位：kg
          "paramsOutDescription": "When the system calculates output weight less than this value, it will not be recorded as a valid output operation.Recommended Range: 50-200kg, adjustable based on device accuracy.", // 出料误差阈值：当系统计算出料重量小于此值时，将不记录为有效出料操作。建议范围：50-200kg，可根据设备精度调整。
          "paramsInDescription": " When the system calculates input weight less than this value, it will not be recorded as a valid input operation.Recommended Range: 50-200kg, avoid false triggering of input records.", // 进料误差阈值：当系统计算出进料重量小于此值时，将不记录为有效进料操作。建议范围：50-200kg，避免误触发进料记录。
          "paramsCalcErrorDescription": "During system calculation, weight changes less than this value are considered normal fluctuations.Influencing Factors: Wind, temperature changes, device vibration and other environmental factors." // 计算容差范围：系统计算过程中，重量变化小于此值时视为正常波动。影响因素：风力、温度变化、设备振动等环境因素。
      },
      "msg": {
          "errorMessage": "Error Message", // 错误信息
          "saveSuccess": "Save Success", // 保存成功
          "deleteSuccess": "Delete Success", // 删除成功
          "updateSuccess": "Update Success" // 修改成功
      },
      "curve": {
        "dataTrend": "Data Trend", // 数据趋势
        "type": "Type", // 类型
        "selectType": "Please select type", // 请选择类型
        "last1Day": "Last 1 Day", // 近1天
        "last2Days": "Last 2 Days", // 近2天
        "last3Days": "Last 3 Days", // 近3天
        "last30Days": "Last 1 Month", // 近1月
        "last60Days": "Last 2 Months", // 近2月
        "last90Days": "Last 3 Months", // 近3月
        "last180Days": "Last 6 Months", // 近半年
        "custom": "Custom", // 自定义
        "date": "Date", // 日期
        "startDate": "Start Date", // 开始日期
        "endDate": "End Date", // 结束日期
        "exportData": "Export", // 导出数据
        "dataCurve": "Data Curve" // 数据曲线
    },
    "status": {
        "notSet": "Not Set", // 未设置
        "unCalibrated": "Unclibrated", // 未标定
        "roughCalibration": "Rough Calibration", // 粗略标定
        "calibrationComplete": "Calibration Complete", // 标定完成
        "preciseCalibration": "Precise Calibration", // 精确标定
        "sensorFault": "Sensor Fault" // 传感器故障
    },
    "channels": {
        "ch1": "Channel 1", // 1通道
        "ch2": "Channel 2", // 2通道
        "ch3": "Channel 3", // 3通道
        "ch4": "Channel 4", // 4通道
        "ch5": "Channel 5", // 5通道
        "ch6": "Channel 6", // 6通道
        "ch7": "Channel 7", // 7通道
        "ch8": "Channel 8", // 8通道
        "ch9": "Channel 9", // 9通道
        "ch10": "Channel 10", // 10通道
        "ch11": "Channel 11", // 11通道
        "ch12": "Channel 12", // 12通道
        "ch13": "Channel 13", // 13通道
        "ch14": "Channel 14", // 14通道
        "ch15": "Channel 15", // 15通道
        "ch16": "Channel 16", // 16通道
        "ch17": "Channel 17", // 17通道
        "ch18": "Channel 18", // 18通道
        "ch19": "Channel 19", // 19通道
        "ch20": "Channel 20", // 20通道
        "ch21": "Channel 21", // 21通道
        "ch22": "Channel 22", // 22通道
        "ch23": "Channel 23", // 23通道
        "ch24": "Channel 24", // 24通道
        "ch25": "Channel 25", // 25通道
        "ch26": "Channel 26", // 26通道
        "ch27": "Channel 27", // 27通道
        "ch28": "Channel 28", // 28通道
        "ch29": "Channel 29", // 29通道
        "ch30": "Channel 30", // 30通道
        "ch31": "Channel 31", // 31通道
        "ch32": "Channel 32" // 32通道
    }
    }
  }
 
  export default en